<template>
    <div class="model-management">
        <!-- 搜索栏 -->
        <div class="search-bar">
            <el-form :inline="true" :model="searchForm">
                <el-form-item label="模型分类">
                    <el-select v-model="searchForm.category" placeholder="全部" clearable style="width: 180px">
                        <el-option label="图片模型" value="image" />
                        <el-option label="视频模型" value="video" />
                    </el-select>
                </el-form-item>
                <el-form-item label="模型名称">
                    <el-input v-model="searchForm.name" placeholder="请输入模型名称" clearable />
                </el-form-item>
                <el-form-item>
                    <el-button @click="resetSearch">重置</el-button>
                    <el-button type="primary" @click="handleSearch">查询</el-button>
                </el-form-item>
            </el-form>
            <el-button class="add-btn" type="primary" @click="openDialog('add')">
                <el-icon>
                    <Plus />
                </el-icon> 新增模型
            </el-button>
        </div>

        <!-- 主表格 -->
        <div class="table-container">
            <el-table class="model-table" :data="tableData" style="width: 100%" height="100%" v-loading="loading">
                <el-table-column type="selection" width="55" />
                <el-table-column label="模型分类" width="120">
                    <template #default="scope">
                        <el-tag :type="scope.row.category === 'video' ? 'primary' : 'success'">
                            {{ scope.row.category === 'video' ? '视频模型' : '图片模型' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="模型名称" min-width="100">
                    <template #default="scope">
                        <div class="model-info">
                            <el-avatar :size="40" :src="scope.row.logo" />
                            <span style="margin-left: 10px">{{ scope.row.name }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="origin" label="来源渠道" min-width="180" show-overflow-tooltip>
                    <template #default="scope">
                        <span :class="['origin-text', { empty: !scope.row.origin }]">
                            {{ scope.row.origin || '未设置' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="显示顺序" width="160" align="center">
                    <template #default="scope">
                        <el-input-number v-model="scope.row.sort_order" :min="0" :step="1" :precision="0" size="small"
                            controls-position="right" :disabled="scope.row.sortSaving"
                            @focus="rememberSortOrder(scope.row)" @change="(val) => quickUpdateSort(scope.row, val)" />
                    </template>
                </el-table-column>
                <el-table-column label="前端显示" width="110" align="center">
                    <template #default="scope">
                        <el-switch v-model="scope.row.show_in_catalog" :active-value="1" :inactive-value="0"
                            :loading="scope.row.catalogSaving"
                            @change="(val) => quickUpdateCatalogVisibility(scope.row, val)" />
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="100">
                    <template #default="scope">
                        <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
                            @change="(val) => quickUpdateStatus(scope.row, val)" />
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" fixed="right">
                    <template #default="scope">
                        <el-button link type="primary" @click="openDialog('edit', scope.row)">
                            配置价格
                        </el-button>
                        <el-button class="del-but" link type="danger" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-wrapper">
                <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize" :total="total"
                    @size-change="fetchList" @current-change="fetchList" />
            </div>
        </div>

        <!-- 核心弹窗：包含动态价格表格 -->
        <el-dialog v-model="dialogVisible" :title="dialogTitle" width="1180px" class="model-config-dialog"
            :close-on-click-modal="false">
            <el-form label-position="top">
                <div class="config-section">
                    <div class="section-heading">
                        <span class="section-index">01</span>
                        <div><strong>基础身份</strong><small>用于程序匹配与后台识别</small></div>
                    </div>
                    <el-row :gutter="18">
                        <el-col :span="8">
                            <el-form-item label="模型分类">
                                <el-select v-model="formData.baseInfo.category" placeholder="请选择"
                                    popper-class="model-dark-popper">
                                    <el-option label="图片模型" value="image" />
                                    <el-option label="视频模型" value="video" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="模型标识 (model_key)">
                                <el-input v-model="formData.baseInfo.model_key" placeholder="如: jmeng / bananaPro"
                                    :disabled="dialogMode === 'edit'" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="模型名称">
                                <el-input v-model="formData.baseInfo.name" placeholder="如: 香蕉" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="来源渠道">
                                <el-input v-model="formData.baseInfo.origin" maxlength="100" show-word-limit
                                    placeholder="如: OpenAI、火山引擎、第三方API" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="系列标识">
                                <el-input v-model="formData.baseInfo.group_key" placeholder="如: jmeng / gpt" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="系列名称">
                                <el-input v-model="formData.baseInfo.group_name" placeholder="如: 即梦2.0 / GPT-2" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <div class="config-section">
                    <div class="section-heading">
                        <span class="section-index">02</span>
                        <div><strong>前端展示</strong><small>控制模型卡片的图片、文案与排列</small></div>
                    </div>
                    <el-row :gutter="18">
                        <el-col :span="24">
                            <el-form-item label="图片路径">
                                <el-input v-model="formData.baseInfo.image_path" placeholder="/images/jmeng.png" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="模型描述">
                                <el-input v-model="formData.baseInfo.description" type="textarea" :rows="2"
                                    placeholder="前端展示的模型说明" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <div class="config-section">
                    <div class="section-heading">
                        <span class="section-index">03</span>
                        <div><strong>生成能力</strong><small>配置比例、时长与素材数量限制</small></div>
                    </div>
                    <el-row :gutter="18">
                        <el-col :span="16">
                            <el-form-item label="支持比例（可输入后回车）">
                                <el-select v-model="formData.baseInfo.ratio_options" multiple filterable allow-create
                                    default-first-option placeholder="如: 16:9、9:16、1:1"
                                    popper-class="model-dark-popper">
                                    <el-option v-for="item in commonRatios" :key="item" :label="item" :value="item" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="默认比例">
                                <el-select v-model="formData.baseInfo.default_ratio" filterable allow-create
                                    placeholder="如: 16:9" popper-class="model-dark-popper">
                                    <el-option v-for="item in formData.baseInfo.ratio_options" :key="item" :label="item"
                                        :value="item" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="时长类型">
                                <el-select v-model="formData.baseInfo.duration_type" popper-class="model-dark-popper">
                                    <el-option label="不限制/不显示" value="none" />
                                    <el-option label="连续范围" value="range" />
                                    <el-option label="固定选项" value="list" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="formData.baseInfo.duration_type === 'range'" :span="8">
                            <el-form-item label="最小时长（秒）">
                                <el-input-number v-model="formData.baseInfo.duration_min" :min="0"
                                    style="width: 100%" />
                            </el-form-item>
                        </el-col>
                        <el-col v-if="formData.baseInfo.duration_type === 'range'" :span="8">
                            <el-form-item label="最大时长（秒）">
                                <el-input-number v-model="formData.baseInfo.duration_max" :min="0"
                                    style="width: 100%" />
                            </el-form-item>
                        </el-col>
                        <el-col v-if="formData.baseInfo.duration_type === 'list'" :span="16">
                            <el-form-item label="固定时长（可输入后回车）">
                                <el-select v-model="formData.baseInfo.duration_values" multiple filterable allow-create
                                    default-first-option placeholder="如: 10、15、16" popper-class="model-dark-popper">
                                    <el-option v-for="item in commonDurations" :key="item" :label="`${item} 秒`"
                                        :value="item" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <!-- 第二部分：动态价格列表 -->
                <div class="price-box config-section">
                    <div class="box-header">
                        <div class="section-heading compact">
                            <span class="section-index">04</span>
                            <div><strong>版本与价格</strong><small>配置上游版本、计费方式和销售价格</small></div>
                        </div>
                        <el-button type="primary" size="small" @click="addPriceRow">+ 添加一行配置</el-button>
                    </div>

                    <el-table :data="formData.priceList" border size="small">
                        <el-table-column label="前端版本名" min-width="130">
                            <template #default="scope">
                                <el-input v-model="scope.row.display_version" size="small" placeholder="快速版/固定" />
                            </template>
                        </el-table-column>
                        <el-table-column label="上游版本号 (Version)" min-width="240">
                            <template #default="scope">
                                <el-input v-model="scope.row.version" size="small" placeholder="nano-banana-pro" />
                            </template>
                        </el-table-column>
                        <el-table-column label="计费方式" width="100">
                            <template #default="scope">
                                <el-select v-model="scope.row.billing_type" size="small"
                                    popper-class="model-dark-popper">
                                    <el-option label="按次" value="次" />
                                    <el-option label="按秒" value="秒" />
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="清晰度" width="100">
                            <template #default="scope">
                                <el-select v-model="scope.row.resolution" size="small" clearable placeholder="可选"
                                    popper-class="model-dark-popper">
                                    <el-option label="1k" value="1k" />
                                    <el-option label="2k" value="2k" />
                                    <el-option label="4k" value="4k" />
                                    <el-option label="480p" value="480p" />
                                    <el-option label="540p" value="540p" />
                                    <el-option label="720p" value="720p" />
                                    <el-option label="768p" value="768p" />
                                    <el-option label="1080p" value="1080p" />
                                </el-select>
                            </template>
                        </el-table-column>

                        <el-table-column label="底价" width="120">
                            <template #default="scope">
                                <el-input-number v-model="scope.row.price" :precision="3" size="small"
                                    style="width: 100%" />
                            </template>
                        </el-table-column>
                        <el-table-column label="官网价" width="120">
                            <template #default="scope">
                                <el-input-number v-model="scope.row.web_price" :precision="3" size="small"
                                    style="width: 100%" />
                            </template>
                        </el-table-column>
                        <el-table-column label="最大图片数" width="120">
                            <template #default="scope">
                                <el-input-number v-model="scope.row.max_images" :min="0" :precision="0" size="small"
                                    style="width: 100%" />
                            </template>
                        </el-table-column>
                        <el-table-column label="最大音频数" width="120">
                            <template #default="scope">
                                <el-input-number v-model="scope.row.max_aideo" :min="0" :precision="0" size="small"
                                    style="width: 100%" />
                            </template>
                        </el-table-column>
                        <el-table-column label="最大视频数" width="120">
                            <template #default="scope">
                                <el-input-number v-model="scope.row.max_video" :min="0" :precision="0" size="small"
                                    style="width: 100%" />
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" width="120">
                            <template #default="scope">
                                <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0" />
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="60">
                            <template #default="scope">
                                <el-button type="danger" :icon="Delete" circle size="small"
                                    @click="removePriceRow(scope.$index)" />
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-form>

            <template #footer>
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm" :loading="submitLoading">保存</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { Plus, Delete } from "@element-plus/icons-vue";
import axios from "axios";

// --- 状态 ---
const loading = ref(false);
const submitLoading = ref(false);
const tableData = ref([]);
const total = ref(0);
const currentPage = ref(1);
const pageSize = ref(10);
const dialogVisible = ref(false);
const dialogMode = ref("add");

const searchForm = reactive({ category: "", name: "" });

// 核心表单数据结构
const formData = reactive({
    baseInfo: {},
    priceList: [] // 这里存动态的多行数据
});

const dialogTitle = computed(() => dialogMode.value === "add" ? "新增模型" : "编辑模型配置");
const commonRatios = ["21:9", "16:9", "3:2", "4:3", "1:1", "3:4", "2:3", "9:16", "9:21", "4:5", "5:4"];
const commonDurations = [3, 4, 5, 6, 8, 10, 12, 15, 16, 20, 30];

const createBaseInfo = () => ({
    id: null,
    category: "",
    model_key: "",
    name: "",
    origin: "",
    group_key: "",
    group_name: "",
    image_path: "",
    description: "",
    ratio_options: [],
    default_ratio: "",
    duration_type: "none",
    duration_min: null,
    duration_max: null,
    duration_values: [],
    sort_order: 0,
    show_in_catalog: 1,
    status: 1
});

const toArray = (value) => {
    if (Array.isArray(value)) return value;
    if (value === null || value === undefined || value === "") return [];
    try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return String(value).split(",").map(item => item.trim()).filter(Boolean);
    }
};

// --- 方法 ---

// 1. 获取列表
const fetchList = async () => {
    loading.value = true;
    try {
        const res = await axios.get(`/admin/getModelList`, {
            params: { page: currentPage.value, pageSize: pageSize.value, ...searchForm }
        });
        console.log("模型列表", res.data, window.location.origin)
        const { msg, data } = res.data
        if (msg === 'success') {
            const API_URL = axios.defaults.baseURL || window.location.origin;
            tableData.value = data.list.map(item => {
                return {
                    ...item,
                    sort_order: Number(item.sort_order || 0),
                    show_in_catalog: Number(item.show_in_catalog ?? 1),
                    sortSaving: false,
                    catalogSaving: false,
                    logo: `${API_URL}/getfile/logo/${item.name}.png`
                };
            }).sort((a, b) =>
                Number(a.sort_order || 0) - Number(b.sort_order || 0) ||
                Number(a.id || 0) - Number(b.id || 0)
            );
            total.value = res.data.data.total;
        }
    } catch (e) {
        ElMessage.error("获取列表失败");
    } finally {
        loading.value = false;
    }
};

// 2. 打开弹窗
const openDialog = async (mode, row = null) => {
    dialogMode.value = mode;
    // 重置
    formData.baseInfo = createBaseInfo();
    formData.priceList = [];

    if (mode === 'edit' && row) {
        // 回显基础信息
        formData.baseInfo = {
            ...createBaseInfo(),
            ...row,
            ratio_options: toArray(row.ratio_options),
            duration_values: toArray(row.duration_values).map(Number),
            duration_min: row.duration_min === null || row.duration_min === undefined || row.duration_min === ""
                ? null
                : Number(row.duration_min),
            duration_max: row.duration_max === null || row.duration_max === undefined || row.duration_max === ""
                ? null
                : Number(row.duration_max)
        };
        // 加载价格列表
        try {
            const res = await axios.get('/admin/getModelDetail', { params: { model_id: row.id } });
            console.log("子表数据", res.data)
            if (res.data.code === 200) {
                const rawList = res.data.data.priceList || [];
                formData.priceList = rawList.map(item => ({
                    ...item,
                    display_version: item.display_version || "固定",
                    price: Number(item.price), // 关键：强制转换为数字
                    web_price: Number(item.web_price), // 关键：强制转换为数字
                    max_images: Number(item.max_images || 0),
                    max_aideo: Number(item.max_aideo || 0),
                    max_video: Number(item.max_video || 0)
                }));
            }
        } catch (e) {
            console.error(e);
        }
    }
    dialogVisible.value = true;
};

// 3. 动态表格操作
const addPriceRow = () => {
    formData.priceList.push({
        display_version: '固定',
        version: '',
        billing_type: '次',
        resolution: '',
        max_images: 0,
        max_aideo: 0,
        max_video: 0,
        price: 0,
        web_price: 0,
        status: 1
    });
};
const removePriceRow = (index) => {
    formData.priceList.splice(index, 1);
};

// 4. 提交保存
const submitForm = async () => {
    if (!formData.baseInfo.model_key || !formData.baseInfo.name || !formData.baseInfo.category) {
        return ElMessage.warning("请填写模型标识、名称和分类");
    }

    formData.baseInfo.origin = String(formData.baseInfo.origin || '').trim();
    if (!formData.baseInfo.origin) {
        return ElMessage.warning("请填写模型来源渠道");
    }

    if (formData.baseInfo.default_ratio &&
        !formData.baseInfo.ratio_options.includes(formData.baseInfo.default_ratio)) {
        return ElMessage.warning("默认比例必须包含在支持比例中");
    }

    const invalidPrice = formData.priceList.some(item =>
        !String(item.display_version || "").trim() ||
        !String(item.version || "").trim() ||
        !item.billing_type ||
        Number(item.price) < 0 ||
        Number(item.web_price) < 0 ||
        !Number.isInteger(Number(item.max_images)) || Number(item.max_images) < 0 ||
        !Number.isInteger(Number(item.max_aideo)) || Number(item.max_aideo) < 0 ||
        !Number.isInteger(Number(item.max_video)) || Number(item.max_video) < 0
    );
    if (invalidPrice) {
        return ElMessage.warning("请完整填写型号配置；素材数量必须是大于等于 0 的整数");
    }

    submitLoading.value = true;
    try {
        // 构造 payload
        const payload = {
            baseInfo: formData.baseInfo,
            priceList: formData.priceList.map(item => ({
                ...item,
                max_images: Number(item.max_images || 0),
                max_aideo: Number(item.max_aideo || 0),
                max_video: Number(item.max_video || 0)
            }))
        };

        const res = await axios.post('/admin/saveModel', payload);
        if (res.data.code === 200) {
            ElMessage.success("保存成功");
            dialogVisible.value = false;
            fetchList();
        } else {
            ElMessage.error(res.data.message);
        }
    } catch (e) {
        ElMessage.error("网络错误");
    } finally {
        submitLoading.value = false;
    }
};

// 5. 快速开关状态 (不打开弹窗)
const quickUpdateStatus = async (row, val) => {
    const oldStatus = Number(val) === 1 ? 0 : 1;

    try {
        const res = await axios.post('/admin/saveModel', {
            baseInfo: {
                id: row.id,
                category: row.category,
                model_key: row.model_key,
                name: row.name,
                origin: row.origin,
                status: Number(val)
            },
            priceList: null
        });

        if (res.data.code !== 200) {
            throw new Error(res.data.message || '状态更新失败');
        }

        ElMessage.success("状态更新成功");

        // 重新读取数据库状态，避免页面显示与数据库不一致
        await fetchList();
    } catch (error) {
        row.status = oldStatus;

        ElMessage.error(
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            "状态更新失败"
        );
    }
};

// 控制模型是否出现在用户端的图片/视频模型选择列表中
const quickUpdateCatalogVisibility = async (row, val) => {
    const oldValue = Number(val) === 1 ? 0 : 1;
    row.catalogSaving = true;

    try {
        const res = await axios.post('/admin/saveModel', {
            baseInfo: {
                id: row.id,
                category: row.category,
                model_key: row.model_key,
                name: row.name,
                origin: row.origin,
                show_in_catalog: Number(val)
            },
            priceList: null
        });

        if (res.data.code !== 200) {
            throw new Error(res.data.message || '前端显示状态更新失败');
        }

        ElMessage.success(
            Number(val) === 1
                ? "已加入前端模型列表"
                : "已从前端模型列表隐藏"
        );
    } catch (error) {
        row.show_in_catalog = oldValue;
        ElMessage.error(
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            "前端显示状态更新失败"
        );
    } finally {
        row.catalogSaving = false;
    }
};

// 记住修改前的顺序，保存失败时用于恢复
const rememberSortOrder = (row) => {
    row.sortOrderBeforeEdit = Number(row.sort_order || 0);
};

// 在模型列表中直接修改显示顺序
const quickUpdateSort = async (row, val) => {
    const nextSortOrder = Math.max(0, Math.trunc(Number(val) || 0));
    const oldSortOrder = Number(row.sortOrderBeforeEdit ?? row.sort_order ?? 0);

    row.sort_order = nextSortOrder;
    row.sortSaving = true;

    try {
        const res = await axios.post('/admin/saveModel', {
            baseInfo: {
                id: row.id,
                category: row.category,
                model_key: row.model_key,
                name: row.name,
                origin: row.origin,
                sort_order: nextSortOrder
            },
            priceList: null
        });

        if (res.data.code !== 200) {
            throw new Error(res.data.message || '顺序保存失败');
        }

        row.sortOrderBeforeEdit = nextSortOrder;
        tableData.value.sort((a, b) =>
            Number(a.sort_order || 0) - Number(b.sort_order || 0) ||
            Number(a.id || 0) - Number(b.id || 0)
        );
        ElMessage.success("显示顺序已更新");
    } catch (error) {
        row.sort_order = oldSortOrder;
        ElMessage.error(
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            "顺序保存失败"
        );
    } finally {
        row.sortSaving = false;
    }
};

// 6. 删除
const handleDelete = (row) => {
    ElMessageBox.confirm(`确定删除【${row.name}】吗？`, "提示", { type: 'warning' }).then(async () => {
        await axios.post('/admin/deleteModel', { ids: [row.id] });
        ElMessage.success("删除成功");
        fetchList();
    });
};

const handleSearch = () => { currentPage.value = 1; fetchList(); };
const resetSearch = () => { searchForm.category = ""; searchForm.name = ""; handleSearch(); };

onMounted(() => {
    fetchList();
});
</script>

<style scoped>
/* 模拟截图中的暗黑风格 */
.model-management {
    background-color: #0b111e;
    color: #fff;
    padding: 20px;
    height: 100%;
    min-height: 0;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

:global(.el-main:has(.model-management)) {
    height: calc(100vh - 60px);
    padding: 0;
    overflow: hidden;
    background-color: #0b111e;
}

.search-bar {
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    background: #151d2c;
    padding: 20px;
    border-radius: 8px;

    /* 调整 label 的颜色和边距，不要用 140px 那么宽 */
    :deep(.el-form-item__label) {
        color: #a3b1bf;
        font-weight: normal;
        padding-right: 12px;
        /* 给 label 和输入框留点呼吸空间 */
    }

    /* 让每个表单项之间有固定的间隔 */
    :deep(.el-form-item) {
        margin-right: 24px;
        margin-bottom: 0;
        /* 行内表单去掉底边距 */
    }


}

:deep(.el-form-item__label) {
    color: #a3b1bf;
}

:deep(.el-input__wrapper),
:deep(.el-select__wrapper) {
    background-color: #1a2333 !important;
    box-shadow: none !important;
    border: 1px solid #2d3a4f;
    height: 30px;
}

:deep(.el-textarea__inner) {
    color: #e6edf7;
    background: #1a2333;
    border: 1px solid #2d3a4f;
    box-shadow: none;
    resize: vertical;
}

:deep(.el-textarea__inner:focus) {
    border-color: #4c8dff;
    box-shadow: 0 0 0 2px rgb(76 141 255 / 12%);
}

:deep(.el-input-number) {
    background: #1a2333;
}

:deep(.el-input-number__decrease),
:deep(.el-input-number__increase) {
    color: #8fa2bd;
    background: #141c29;
    border-color: #2d3a4f;
}

:deep(.el-input-number__decrease:hover),
:deep(.el-input-number__increase:hover) {
    color: #69a2ff;
    background: #202c40;
}

:deep(.el-input-number .el-input__wrapper) {
    border-radius: 6px;
}

:deep(.el-input.is-disabled .el-input__wrapper) {
    background: #121a27 !important;
    border-color: #263246;
}

:deep(.el-input.is-disabled .el-input__inner) {
    color: #72819a;
    -webkit-text-fill-color: #72819a;
}

:deep(.el-input__inner) {
    color: #fff;
}

:deep(.el-input__count) {
    color: #7f8da3;
    background: transparent;
}

:deep(.el-input__count-inner) {
    color: #7f8da3;
    background: #1a2333;
}

.config-section {
    margin-bottom: 16px;
    padding: 18px 18px 2px;
    background: linear-gradient(145deg, #111927 0%, #0f1622 100%);
    border: 1px solid #263349;
    border-radius: 10px;
}

.section-heading {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
}

.section-heading.compact {
    margin-bottom: 0;
}

.section-heading strong {
    display: block;
    color: #edf4ff;
    font-size: 15px;
    line-height: 20px;
}

.section-heading small {
    display: block;
    margin-top: 1px;
    color: #6f809b;
    font-size: 12px;
}

.section-index {
    display: grid;
    width: 32px;
    height: 32px;
    place-items: center;
    color: #79aaff;
    background: #172745;
    border: 1px solid #294978;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 700;
}

:global(.model-config-dialog) {
    --el-bg-color: #0d141e;
    --el-bg-color-overlay: #0d141e;
    --el-text-color-primary: #e7eef9;
    --el-text-color-regular: #aab7ca;
    --el-border-color: #2b384d;
    background: #0d141e !important;
    border: 1px solid #27354a;
    border-radius: 12px;
}

:global(.model-config-dialog .el-dialog__header) {
    padding: 18px 22px;
    margin-right: 0;
    border-bottom: 1px solid #253247;
}

:global(.model-config-dialog .el-dialog__title) {
    color: #f1f6ff;
    font-weight: 600;
}

:global(.model-config-dialog .el-dialog__body) {
    max-height: 72vh;
    padding: 18px 22px;
    overflow-y: auto;
}

:global(.model-config-dialog .el-dialog__footer) {
    padding: 14px 22px 18px;
    border-top: 1px solid #253247;
}

:global(.model-dark-popper.el-popper) {
    background: #141d2b !important;
    border: 1px solid #30415a !important;
    box-shadow: 0 14px 36px rgb(0 0 0 / 45%);
}

:global(.model-dark-popper .el-popper__arrow::before) {
    background: #141d2b !important;
    border-color: #30415a !important;
}

:global(.model-dark-popper .el-select-dropdown__item) {
    color: #b9c6d8;
    background: transparent;
}

:global(.model-dark-popper .el-select-dropdown__item.hover),
:global(.model-dark-popper .el-select-dropdown__item:hover) {
    color: #eef5ff;
    background: #202d41;
}

:global(.model-dark-popper .el-select-dropdown__item.is-selected) {
    color: #75aaff;
    background: #1b2b45;
}

:global(.model-dark-popper .el-select-dropdown__empty) {
    color: #7888a1;
}

.table-container {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #151d2c;
    padding: 20px;
    border-radius: 8px;

    .del-but {
        margin-left: 50px;
    }
}

.pagination-wrapper {
    flex-shrink: 0;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
}

.model-table {
    flex: 1;
    min-height: 0;
}

:deep(.el-table) {
    --el-table-bg-color: transparent;
    --el-table-tr-bg-color: transparent;
    --el-table-header-bg-color: #1a2333;
    --el-table-border-color: #2d3a4f;
    --el-table-text-color: #d1d9e2;
}

.tag-category {
    background: #1d2b3a;
    color: #409eff;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
}

.model-info {
    display: flex;
    align-items: center;
    height: 50px;

    .el-avatar {
        background: none !important;
    }
}

.origin-text {
    color: #d1d9e2;
}

.origin-text.empty {
    color: #64748b;
}

.table-footer {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* 右侧抽屉样式 */
:deep(.dark-drawer) {
    background-color: #151d2c !important;
    color: #fff;
}


.submit-btn {
    background: linear-gradient(90deg, #5b67ff 0%, #8e54e9 100%);
    border: none;
}

.add-btn {
    background: linear-gradient(90deg, #409eff 0%, #67c23a 100%);
    border: none;
}

:deep(.el-select__placeholder) {
    color: #fff;
}
</style>
